import type { Sector } from "../models/Sector.interface";
import { TreeNodes } from "~/core/models/TreeNodes.class";

/**
 * Rebuild the sector hierarchy as a LxcTreeNodesModel hierarchy recursively
 * @param sector Root sector to transform
 * @param granted boolean true to override the granted status and set it as true, default false
 * @param result the list of all LxcTreeNodesModel
 */
export function mapSectorsToTreeNodes(
  sector: Sector,
  granted: boolean = false,
  result: TreeNodes[] = [],
): TreeNodes[] {
  const sectorTreeNode = new TreeNodes(
    sector.code.toString(),
    sector.name,
    !granted && !sector.statuses.granted,
  );
  if (sector.children?.length > 0) {
    const childrenTreeNodes: TreeNodes[] = [];
    for (const child of sector.children) {
      mapSectorsToTreeNodes(
        child,
        granted || sector.statuses.granted,
        childrenTreeNodes,
      );
    }
    sectorTreeNode.children = childrenTreeNodes;
  }

  result.push(sectorTreeNode);

  return result;
}
